import rootPath, { RouteProps as ParentRouteProps } from "../routes-path";

export default rootPath + "/prihlaska/:applicationId?/:hashCode?";

export interface RouteProps extends ParentRouteProps {
    applicationId?: string;
    hashCode?: string;
}
